// extracted by mini-css-extract-plugin
export var avatarContainer = "_dp-0";
export var avatarTypingWave = "_dp-i";
export var gray = "_dp-f";
export var green = "_dp-c";
export var icon = "_dp-9";
export var image = "_dp-1";
export var lg = "_dp-6";
export var md = "_dp-5";
export var presenceDot = "_dp-b";
export var red = "_dp-d";
export var sm = "_dp-4";
export var status = "_dp-a";
export var typingDot = "_dp-h";
export var typingPill = "_dp-g";
export var xl = "_dp-7";
export var xs = "_dp-3";
export var xxl = "_dp-8";
export var xxs = "_dp-2";
export var yellow = "_dp-e";